import { useState, useEffect } from "react";
import { StlViewer } from "react-stl-viewer";
import { Button } from 'antd';
import Cookies from "js-cookie";

function Reference({ reference }) {
    const [show, setShow] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const stlStyle = {
        top: 0,
        left: 0,
        width: '100%',
        height: '200px',
        borderRadius: '10px',
        backgroundColor: '#bcf7ed'
    };

    useEffect(() => {
        if (reference.size.split('mb')[0] <= 5 || (Cookies.get('loadedReferences') && JSON.parse(Cookies.get('loadedReferences')).some(x => x.url === reference.url))) {
            setIsLoading(true);
            setShow(true);
        }
    }, [reference]);

    function handleShow() {
        setIsLoading(true);
        setShow(true);
        let loadedReferences = Cookies.get('loadedReferences');
        Cookies.set('loadedReferences', JSON.stringify(!loadedReferences ? [reference] : [...loadedReferences, reference]));
    }

    return (
        <div className="Reference">
            {show ? (<div>
                {isLoading && (
                    <div className='loading-reference mb-3 d-flex justify-content-center align-items-center'>
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )}

                <StlViewer
                    key={reference.url}
                    className='stl-model mb-3'
                    style={stlStyle}
                    orbitControls
                    shadows
                    url={reference.url}
                    onFinishLoading={() => setIsLoading(false)}
                />
            </div>) : (<div>
                <div className='empty-reference mb-3 d-flex justify-content-center align-items-center'>
                    <div className='mock-element'></div>
                    <Button type="primary" onClick={handleShow}>Show reference ({reference.size.substring(0, reference.size.length - 2)} MB)</Button>
                </div>
            </div>)}
        </div>
    )
}

export default Reference;